"use strict";

(function () {
	/*
	 * Helpers (replacement for the legacy library APIs this file used to rely on)
	 */

	// Runtime data store, equivalent of the legacy .data(key, value) setter.
	const dataStore = new WeakMap();

	const camelCase = (key) =>
		key.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());

	// Same type coercion as the legacy .data() getter for data-* attributes.
	const coerceData = (value) => {
		if (value === "true") return true;
		if (value === "false") return false;
		if (value === "null") return null;
		if (value === +value + "") return +value;
		if (/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/.test(value)) {
			try {
				return JSON.parse(value);
			} catch (e) {
				return value;
			}
		}
		return value;
	};

	const getData = (el, key) => {
		if (!el) return undefined;
		const name = camelCase(key);
		const store = dataStore.get(el);
		if (store && Object.prototype.hasOwnProperty.call(store, name)) {
			return store[name];
		}
		const raw = el.dataset ? el.dataset[name] : undefined;
		return raw === undefined ? undefined : coerceData(raw);
	};

	const setData = (el, key, value) => {
		if (!el) return;
		const store = dataStore.get(el) || {};
		store[camelCase(key)] = value;
		dataStore.set(el, store);
	};

	const safeQueryAll = (selector) => {
		try {
			return Array.from(document.querySelectorAll(selector));
		} catch (e) {
			return [];
		}
	};

	const safeClosest = (el, selector) => {
		if (!el || typeof el.closest !== "function") return null;
		try {
			return el.closest(selector);
		} catch (e) {
			return null;
		}
	};

	// Resolve an element or selector string to the unique .popup containers.
	const resolvePopups = (target) => {
		const elements =
			typeof target === "string"
				? safeQueryAll(target)
				: target instanceof Element
				? [target]
				: [];
		const popups = [];
		elements.forEach((el) => {
			const popup = el.closest(".popup");
			if (popup && !popups.includes(popup)) popups.push(popup);
		});
		return popups;
	};

	const onAnimationEndOnce = (el, handler) => {
		el.addEventListener("animationend", handler, { once: true });
	};

	const splitClasses = (names) =>
		String(names || "")
			.split(/\s+/)
			.filter(Boolean);

	/*
	 * Popup controller
	 */
	const adpPopup = {
		sPrevious: window.scrollY,
		sDirection: "down",
		eventsBound: false,
		initializedPopups: new WeakSet(),
		closeScrollHandlers: new WeakMap(),

		/*
		 * Initialize
		 */
		init: function () {
			adpPopup.popupInit();

			// Init events.
			adpPopup.events();
		},

		/*
		 * Events (bound once, delegated on document)
		 */
		events: function () {
			if (adpPopup.eventsBound) return;
			adpPopup.eventsBound = true;

			document.addEventListener("click", function (e) {
				const target = e.target instanceof Element ? e.target : null;
				if (!target) return;

				const closeBtn = target.closest(".popup-close");
				if (closeBtn) adpPopup.closePopup(closeBtn);

				const acceptBtn = target.closest(".popup-accept");
				if (acceptBtn) {
					adpPopup.acceptPopup(acceptBtn);
					adpPopup.closePopup(acceptBtn);
				}

				const ageCloseBtn = target.closest(".age-verification__popup-close");
				if (ageCloseBtn) {
					adpPopup.agePopup(ageCloseBtn);
					adpPopup.closePopup(ageCloseBtn);
				}

				if (target.closest(".age-verification__button-no")) {
					adpPopup.ageDeclined();
				}

				// Checking this will cause popup to close when user clicks on overlay.
				if (target.closest(".popup-overlay")) {
					document
						.querySelectorAll('.popup-open[data-overlay-close="true"]')
						.forEach((popup) => adpPopup.closePopup(popup));
				}
			});

			// Checking this will cause popup to close when user presses key.
			document.addEventListener("keyup", function (e) {
				// Press ESC to Close.
				if (e.key === "Escape") {
					document
						.querySelectorAll('.popup-open[data-esc-close="true"]')
						.forEach((popup) => adpPopup.closePopup(popup));
				}

				// Press F4 to Close.
				if (e.key === "F4") {
					document
						.querySelectorAll('.popup-open[data-f4-close="true"]')
						.forEach((popup) => adpPopup.closePopup(popup));
				}
			});

			// Set scroll direction.
			document.addEventListener(
				"scroll",
				function () {
					const scrollCurrent = window.scrollY;

					adpPopup.sDirection =
						scrollCurrent > adpPopup.sPrevious ? "down" : "up";

					adpPopup.sPrevious = scrollCurrent;
				},
				{ passive: true }
			);
		},

		/*
		 * Init popup elements
		 */
		popupInit: function () {
			document.querySelectorAll(".popup").forEach(function (popup) {
				if (adpPopup.initializedPopups.has(popup)) return;
				adpPopup.initializedPopups.add(popup);

				// Manual Launch.
				if ("manual" === getData(popup, "open-trigger")) {
					const selector = getData(popup, "open-manual-selector");

					if (selector && typeof selector === "string") {
						safeQueryAll(selector).forEach((el) =>
							el.classList.add("popup-trigger")
						);

						document.addEventListener("click", function (e) {
							const matched = safeClosest(e.target, selector);
							if (!matched) return;

							e.preventDefault();

							popup.classList.remove("popup-already-opened");

							adpPopup.openPopup(popup);

							if (matched.classList.contains("popup")) {
								adpPopup.closePopup(selector);
							}
						});
					}
				}

				// Checks whether a popup should be displayed or not.
				if (
					!adpPopup.isAllowPopup(popup) &&
					!popup.classList.contains("age-verification")
				) {
					return;
				}

				adpPopup.openTriggerPopup(popup);
			});
		},

		/*
		 * Trigger open popup
		 */
		openTriggerPopup: function (popup) {
			const trigger = getData(popup, "open-trigger");

			// Age Verification.
			if ("none" === trigger) {
				const ageVerification = adpPopup.getStorage(
					"popup-age-" + getData(popup, "id") || 0
				);

				if (!ageVerification) adpPopup.openPopup(popup);
			}

			// Time Delay.
			if ("delay" === trigger) {
				setTimeout(function () {
					adpPopup.openPopup(popup);
				}, getData(popup, "open-delay-number") * 1000);
			}

			// Exit Intent.
			if ("exit" === trigger) {
				const onMouseMove = function (e) {
					// Get current scroll position
					const scroll =
						window.pageYOffset || document.documentElement.scrollTop;
					if (e.pageY - scroll < 7) {
						adpPopup.openPopup(popup);
						document.removeEventListener("mousemove", onMouseMove);
					}
				};
				document.addEventListener("mousemove", onMouseMove, { passive: true });
			}

			// Scroll Position.
			if ("scroll" === trigger) {
				const pointScrollType = getData(popup, "open-scroll-type");
				const pointScrollPosition = getData(popup, "open-scroll-position");

				// Event scroll.
				document.addEventListener(
					"scroll",
					function () {
						// Type px.
						if ("px" === pointScrollType) {
							if (window.scrollY >= pointScrollPosition) {
								adpPopup.openPopup(popup);
							}
						}

						// Type %.
						if ("%" === pointScrollType) {
							if (adpPopup.getScrollPercent() >= pointScrollPosition) {
								adpPopup.openPopup(popup);
							}
						}
					},
					{ passive: true }
				);
			}

			// Accept Agreement.
			if ("accept" === trigger) {
				const accept = adpPopup.getStorage(
					"popup-accept-" + getData(popup, "id") || 0
				);

				if (!accept) {
					adpPopup.openPopup(popup);
				}
			}
		},

		/*
		 * Trigger close popup
		 */
		closeTriggerPopup: function (popup) {
			const trigger = getData(popup, "close-trigger");

			// Time Delay.
			if ("delay" === trigger) {
				setTimeout(function () {
					adpPopup.closePopup(popup);
				}, getData(popup, "close-delay-number") * 1000);
			}

			// Scroll Position.
			if ("scroll" === trigger) {
				const pointScrollType = getData(popup, "close-scroll-type");
				const pointScrollPosition = getData(popup, "close-scroll-position");
				const initScrollPx = getData(popup, "init-scroll-px");
				const initScrollPercent = getData(popup, "init-scroll-percent");

				// Replace any handler left over from a previous opening.
				const previous = adpPopup.closeScrollHandlers.get(popup);
				if (previous) document.removeEventListener("scroll", previous);

				// Event scroll.
				const onScroll = function () {
					// Type px.
					if ("px" === pointScrollType) {
						if (
							"up" === adpPopup.sDirection &&
							window.scrollY < initScrollPx - pointScrollPosition
						) {
							adpPopup.closePopup(popup);
						}

						if (
							"down" === adpPopup.sDirection &&
							window.scrollY >= initScrollPx + pointScrollPosition
						) {
							adpPopup.closePopup(popup);
						}
					}

					// Type %.
					if ("%" === pointScrollType) {
						if (
							"up" === adpPopup.sDirection &&
							adpPopup.getScrollPercent() <
								initScrollPercent - pointScrollPosition
						) {
							adpPopup.closePopup(popup);
						}

						if (
							"down" === adpPopup.sDirection &&
							adpPopup.getScrollPercent() >=
								initScrollPercent + pointScrollPosition
						) {
							adpPopup.closePopup(popup);
						}
					}
				};

				adpPopup.closeScrollHandlers.set(popup, onScroll);
				document.addEventListener("scroll", onScroll, { passive: true });
			}
		},

		/*
		 * Open popup
		 */
		openPopup: function (popup) {
			if (!popup) return;

			// Hide body scroll.
			if (popup.matches('[data-body-scroll-disable="true"]')) {
				document.body.classList.add("popup-scroll-hidden");
			}

			if (popup.classList.contains("popup-open")) {
				return;
			}

			// Check already opened.
			if (popup.classList.contains("popup-already-opened")) {
				return;
			}

			// Set localStorage of Limit display.
			const limit =
				parseInt(adpPopup.getStorage("popup-" + getData(popup, "id")) || 0) +
				1;

			adpPopup.setStorage("popup-" + getData(popup, "id"), limit, {
				expires: getData(popup, "limit-lifetime"),
			});

			// Display popup.
			popup.classList.add("popup-open");

			// Set current scroll.
			setData(popup, "init-scroll-px", window.scrollY);
			setData(popup, "init-scroll-percent", adpPopup.getScrollPercent());

			// Open animation.
			const animation = getData(popup, "open-animation");

			adpPopup.applyAnimation(popup, animation);

			// Init close trigger.
			adpPopup.closeTriggerPopup(popup);
		},

		/*
		 * Age popup
		 */
		agePopup: function (el) {
			resolvePopups(el).forEach((popup) => {
				// Set localStorage of Age.
				adpPopup.setStorage("popup-age-" + getData(popup, "id"), 1, {
					expires: 360,
				});
			});
		},

		/*
		 * Age declined
		 */
		ageDeclined: function () {
			document
				.querySelectorAll(".age-verification__question")
				.forEach((el) => el.classList.remove("show"));
			document
				.querySelectorAll(".age-verification__declined")
				.forEach((el) => el.classList.add("show"));
		},

		/*
		 * Accept popup
		 */
		acceptPopup: function (el) {
			resolvePopups(el).forEach((popup) => {
				// Set localStorage of Accept.
				adpPopup.setStorage("popup-accept-" + getData(popup, "id"), 1, {
					expires: 360,
				});
			});
		},

		/*
		 * Close popup (accepts an element or a selector string)
		 */
		closePopup: function (el) {
			resolvePopups(el).forEach((popup) => {
				// Close animation.
				const animation = getData(popup, "exit-animation");

				adpPopup.applyAnimation(popup, animation, function () {
					// Already opened.
					popup.classList.add("popup-already-opened");

					// Hide popup.
					popup.classList.remove("popup-open");

					// Stop listening for scroll-to-close once closed.
					const onScroll = adpPopup.closeScrollHandlers.get(popup);
					if (onScroll) {
						document.removeEventListener("scroll", onScroll);
						adpPopup.closeScrollHandlers.delete(popup);
					}

					// Remove classes from body.
					document.body.classList.remove("popup-scroll-hidden");
				});
			});
		},

		/*
		 * Checks whether a popup should be displayed or not
		 */
		isAllowPopup: function (popup) {
			// Has user seen this popup before?
			const limitDisplay = parseInt(getData(popup, "limit-display") || 0);

			const limitDisplayCookie = parseInt(
				adpPopup.getStorage("popup-" + getData(popup, "id"))
			);

			if (
				limitDisplay &&
				limitDisplayCookie &&
				limitDisplayCookie >= limitDisplay
			) {
				return;
			}

			return true;
		},

		/*
		 * Apply animation
		 */
		applyAnimation: function (el, name, callback) {
			const popup = el ? el.closest(".popup") : null;
			if (!popup) return;

			const overlayName =
				typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

			// Overlay Animation.
			const overlay = popup.nextElementSibling;
			if (overlay && overlay.classList.contains("popup-overlay")) {
				overlay.classList.add("popup-animated", overlayName);
				onAnimationEndOnce(overlay, function () {
					overlay.classList.remove("popup-animated", overlayName);
				});
			}

			// Wrap Animation.
			const wrapClasses = ["popup-animated"].concat(splitClasses(name));
			popup.querySelectorAll(".popup-wrap").forEach((wrap) => {
				wrap.classList.add(...wrapClasses);
				onAnimationEndOnce(wrap, function () {
					// remove the animation classes after animation ends
					// required in order to apply new animation on close
					wrap.classList.remove(...wrapClasses);

					if (typeof callback === "function") {
						callback();
					}
				});
			});
		},

		/*
		 * Get cookie
		 */
		getCookie: function (name) {
			const matches = document.cookie.match(
				new RegExp(
					"(?:^|; )" +
						name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
						"=([^;]*)"
				)
			);
			return matches ? decodeURIComponent(matches[1]) : undefined;
		},

		/*
		 * Set cookie
		 */
		setCookie: function (name, value, options) {
			options = options || {};

			options.path = options.hasOwnProperty("path") ? options.path : "/";

			options.expires = parseInt(options.expires);

			if (typeof options.expires == "number" && options.expires) {
				options.expires = new Date().setDate(
					new Date().getDate() + options.expires
				);

				options.expires = new Date(options.expires).toUTCString();
			}

			value = encodeURIComponent(value);

			let updatedCookie = name + "=" + value;

			for (const propName in options) {
				updatedCookie += "; " + propName;
				const propValue = options[propName];
				if (propValue !== true) {
					updatedCookie += "=" + propValue;
				}
			}

			document.cookie = updatedCookie;
		},

		/*
		 * Get local storage
		 */
		getStorage: function (key) {
			let item;
			try {
				item = localStorage.getItem(key);
			} catch (e) {
				return undefined;
			}
			if (!item) return undefined;

			try {
				const parsed = JSON.parse(item);
				if (parsed.expires && Date.now() > parsed.expires) {
					localStorage.removeItem(key);
					return undefined;
				}
				return parsed.value;
			} catch (e) {
				return undefined;
			}
		},

		/*
		 * Set local storage
		 */
		setStorage: function (key, value, options = {}) {
			const data = {
				value,
				expires: null,
			};
			if (options.expires) {
				const expiresDate = new Date();
				expiresDate.setDate(
					expiresDate.getDate() + parseInt(options.expires, 10)
				);
				data.expires = expiresDate.getTime();
			}
			try {
				localStorage.setItem(key, JSON.stringify(data));
			} catch (e) {
				// Storage unavailable (private mode / quota); popup still works.
			}
		},

		/*
		 * Get scroll percent
		 */
		getScrollPercent: function () {
			const h = document.documentElement,
				b = document.body,
				st = "scrollTop",
				sh = "scrollHeight";
			return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
		},
	};

	const start = () => {
		// Initialize.
		adpPopup.init();

		document.addEventListener("shopify:section:load", function () {
			adpPopup.init();
		});

		document.addEventListener("shopify:section:unload", function () {
			document.body.classList.remove("popup-scroll-hidden");
		});
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
})();
